import { render, staticRenderFns } from "./tutor_type.vue?vue&type=template&id=9b8e6096&scoped=true&"
import script from "./tutor_type.vue?vue&type=script&lang=js&"
export * from "./tutor_type.vue?vue&type=script&lang=js&"
import style0 from "./tutor_type.vue?vue&type=style&index=0&id=9b8e6096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8e6096",
  null
  
)

export default component.exports